import { InjectionToken } from '@angular/core';

export const SERVICEMESH_CONFIG = new InjectionToken<unknown>('SERVICEMESH_APP_CONFIG');
